import type { UserGetDTO } from '@szebit-app/sdk/backend';

export class SetUserAction {
  static readonly type = '[User] Set User';

  constructor(readonly user: UserGetDTO) {}
}
